import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import {
  BackgroundColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { Shadows } from '@picsart/design-system/foundation/shadows';
import { Easings } from '@picsart/design-system/foundation/easings';

const useStyles = createUseStyles(
  {
    // Audio placeholder — branded card with glow + waveform
    '@keyframes audioBar': {
      '0%, 100%': { transform: 'scaleY(0.4)' },
      '50%': { transform: 'scaleY(1)' },
    },
    audioPlaceholder: {
      width: '100%',
      aspectRatio: '1 / 1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: Spacings.s16,
      position: 'relative',
      overflow: 'hidden',
      background: `linear-gradient(145deg, ${BackgroundColors.tint1} 0%, ${BackgroundColors.base} 100%)`,
    },
    audioGlow: {
      position: 'absolute',
      top: '30%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 120,
      height: 120,
      borderRadius: CornerRadius.circle,
      background: PrimaryColors.alpha?.alpha10,
      filter: 'blur(32px)',
      pointerEvents: 'none',
    },
    audioGlowLightbox: {
      display: 'none',
    },
    audioPlaceholderLightbox: {
      aspectRatio: 'unset',
      background: 'transparent',
      gap: Spacings.s24,
    },
    // ── Base styles declared before lightbox overrides so CSS cascade works ──
    audioIconRing: {
      width: 52,
      height: 52,
      borderRadius: CornerRadius.circle,
      background: `linear-gradient(135deg, ${PrimaryColors.alpha?.alpha20} 0%, ${PrimaryColors.alpha?.alpha10} 100%)`,
      border: [1.5, 'solid', PrimaryColors.alpha?.alpha20 ?? 'transparent'],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      zIndex: 1,
      boxShadow: Shadows.tint2,
    },
    audioIcon: {
      width: 22,
      height: 22,
      color: PrimaryColors.base.default,
    },
    audioWaveform: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s4,
      height: 24,
      position: 'relative',
      zIndex: 1,
    },
    audioBar: {
      display: 'block',
      width: 3,
      height: 'var(--bar-height, 8px)',
      borderRadius: CornerRadius.r2,
      background: `linear-gradient(to top, ${PrimaryColors.base.default}, ${PrimaryColors.alpha?.alpha50})`,
      animation: `$audioBar 1.2s ${Easings.easeInOut} infinite`,
      transformOrigin: 'center',
    },
    // ── Lightbox overrides — must be declared AFTER base styles to win the cascade ──
    audioIconRingLightbox: {
      width: 320,
      height: 320,
      boxShadow: 'none',
    },
    audioIconLightbox: {
      width: 150,
      height: 150,
    },
    audioWaveformLightbox: {
      gap: Spacings.s6,
      height: 56,
    },
    audioBarLightbox: {
      width: 5,
      borderRadius: CornerRadius.r4,
    },
  },
  { name: 'card-audio' }
);

export default useStyles;
